module.exports = __webpack_public_path__ + "img/00428307001917.64efd679.png";